{
  "nl": {
    "snippets": {
      "labels": {
        "cancel": "Annuleer",
        "confirm": "Bevestigen",
        "create": "Een snippet maken",
        "delete": "Verwijderen",
        "edit": "Bewerken",
        "editTitle": "Snippet bewerken",
        "initMessage": "Selecteer een snippet om hier een voorbeeld te bekijken.",
        "language": "Taal",
        "linkable": "Type",
        "linkableClient": "Team",
        "linkableEmployee": "Persoonlijk",
        "linkablePartner": "Partner",
        "manage": "Beheer je snippets",
        "manageMessage": "Of klik hier om al jouw snippets te beheren binnen de organisatie-instellingen",
        "message": "Bericht",
        "messageError": "Gelieve een bericht te typen",
        "new": "Nieuwe snippet",
        "noSnippets": "Je hebt nog geen snippets.",
        "preview": "Voorbeeld",
        "save": "Opslaan",
        "search": "Zoeken",
        "select": "Selecteer",
        "snippets": "Snippets",
        "title": "Titel",
        "titleError": "Gelieve een titel te geven"
      }
    }
  }
}
